// @core/api/endpoints/webhook/list_webhook_policies.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';
import type {
  ListWebhookPoliciesResponse,
} from '../../../types/webhook';
import type { PaginatedRequest } from '../../../types/pagination';

const BASE_PATH = '/webhook';

/**
 * List webhook policies
 * Returns webhook policies, optionally filtered by scope entity type.
 */
export async function ListWebhookPolicies(
  params?: PaginatedRequest,
  options?: RequestOptions
): Promise<ListWebhookPoliciesResponse> {
  const client = getApiClient();
  const requestPath = `${BASE_PATH}/webhook-policies`;
  const requestOptions = options;
  return client.get<ListWebhookPoliciesResponse>(requestPath, { ...requestOptions, params });
}
